module.exports = __webpack_public_path__ + "static/media/icons.4bbeb9e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons.svg
// module id = 362
// module chunks = 0